import AdditionalMachinesWrapper from '../../components/calculation-form/components/form-items/additional-machines-wrapper'
import { renderCalcPos, onAnyStandardCell } from '../../helpers/helpers'
import type { CalculationColumn } from '../../types/column-types'

export const additionalMachinesColumn: CalculationColumn = {
    dataIndex: ['additional_machines'],
    relationPath: ['additional_machines'],
    title: 'Отд. станок',
    width: 80,
    editable: true,
    FormItem: <AdditionalMachinesWrapper />,
    onCell: onAnyStandardCell,
    render: renderCalcPos(r => r.additional_machines?.map(x => x.name.split(' ')[0]).join(', ')),
}
